import {cva} from 'class-variance-authority';

export const iconButtonVariants = cva(
  `relative inline-flex shrink-0 items-center justify-center rounded-full border border-transparent transition-colors before:absolute before:rounded-full before:content-[''] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed [&>svg]:shrink-0`,
  {
    variants: {
      variant: {
        default: `
          bg-primary-700 text-on-action
          hover:bg-primary-600
          active:bg-primary-800
          focus-visible:bg-primary-800
          disabled:bg-neutral-300 disabled:text-on-disabled
        `,
        primary: `
          bg-primary-700 text-on-action
          hover:bg-primary-600
          active:bg-primary-800
          focus-visible:bg-primary-800
          disabled:bg-neutral-300 disabled:text-on-disabled
        `,
        secondary: `
          border-action text-action
          hover:border-action-hover hover:text-action-hover
          active:border-action-active active:text-action-active
          focus-visible:border-action-active focus-visible:text-action-active
          disabled:border-disabled disabled:text-disabled
        `,
        'secondary-filled': `
          bg-secondary-700 text-on-action
          hover:bg-secondary-600
          active:bg-secondary-800
          focus-visible:bg-secondary-800
          disabled:bg-neutral-300 disabled:text-on-disabled
        `,
        tertiary: `
          bg-neutral-light text-action
          hover:text-action-hover
          active:text-action-active
          focus-visible:text-action-active
          disabled:text-disabled
        `,
        'warning-outline': `
          border-danger-500 text-danger-500
          hover:border-danger-400 hover:text-danger-400
          active:border-danger-600 active:text-danger-600
          focus-visible:border-danger-600 focus-visible:text-danger-600
          disabled:border-danger-200 disabled:text-danger-200
        `,
        warning: `
          text-danger-500
          hover:text-danger-400
          active:text-danger-600
          focus-visible:text-danger-600
          disabled:text-danger-200
        `,
        link: `
          text-action
          hover:text-action-hover
          active:text-action-active
          focus-visible:text-action-active
          disabled:text-disabled
        `,
        ['link-accent']: `
          text-secondary-800
          hover:text-secondary-600
          active:text-secondary-900
          focus-visible:text-secondary-900
          disabled:text-secondary-200
        `,
      },
      size: {
        default: 'size-11 [&>svg]:size-6',
        medium: 'size-11 [&>svg]:size-6',
        large: 'size-13 [&>svg]:size-8',
        small: 'size-8 before:-inset-1.5 [&>svg]:size-4',
        xsmall: 'size-8 [&>svg]:size-4',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
